import ShiftUtils from "services/ShiftUtils";
import DefaultChip from "components/Utils/DefaultChip";
import Avatar from "@material-ui/core/Avatar";
import React from "react";
import ShiftBadge from "components/Schedule/ShiftsEditor/ShiftBadge";

const SmallShiftBadge = ({ event, shifts = [], template, onClick, className, onDelete }) => {
  return (
    <div className="small-shift-pill-wrapper">
      {shifts.map((shift, index) => {
        let fullName = event.names[index] || '';
        let names = fullName.split(' ');
        let name = names
          .map((n) => n.charAt(0))
          .join('')
          .toUpperCase();

        let color = ShiftUtils.getColor(shift, true);

        let style = {
          background: color,
        };

        let shiftClassName = 'small-shift-pill';
        if (className) shiftClassName += ` ${className}`;
        if (shift.approved === false) {
          shiftClassName += ' non-approved';
          fullName = `${fullName} - Not Approved`;
        }
        if (shift.rejected === true) {
          shiftClassName += ' rejected';
          fullName = `${fullName}, Rejected`;
        }

        return (
          <DefaultChip
            key={shift.id || index}
            className={shiftClassName}
            onClick={onClick}
            avatar={<Avatar style={{ background: 'white', color: 'black' }}>{name}</Avatar>}
            alt={fullName}
            style={style}
            element={
              <ShiftBadge
                shift={shift}
                template={template}
                onCLick={onClick}
                className={className}
                onDelete={onDelete}
                hideIcons={true}
                color={color}
              />
            }
          />
        );
      })}
    </div>
  );
};

export default SmallShiftBadge;
